import axios from 'axios';
import cache from '../helpers/redis';

import { CategoryResponse } from '../types/api/CategoriesIndexTypes';

import { ENV } from '../constants/environments';
import { LIBRARY_IDS, CACHE_KEYS } from '../constants/api';
const {
  CATEGORIES_CACHE_KEY_2D,
  CATEGORIES_CACHE_KEY_3D,
} = CACHE_KEYS;
const { LIBRARY_ID_2D, LIBRARY_ID_3D } = LIBRARY_IDS;

const apiUrl: string = `${ENV.api.baseURL}`;

const fetchCategoriesFromBackend = async (library_id: number): Promise<Array<CategoryResponse>> => {
  const categoriesUrl: string = `${apiUrl}/categories?limit=50&library_id=${library_id}`;
  const categoriesRes = await axios.get(categoriesUrl);
  return categoriesRes?.data?.data;
};

const getCategories = async (library_id: number): Promise<Array<CategoryResponse>> => {
  let key: string;
  switch (library_id) {
    case LIBRARY_ID_3D:
      key = CATEGORIES_CACHE_KEY_3D;
      break;
    case LIBRARY_ID_2D:
    default:
      key = CATEGORIES_CACHE_KEY_2D;
      break;
  }
  const { fetchCategoriesFromBackend, cache } = categoriesHelpers;
  return await cache(key, 3600, async () => fetchCategoriesFromBackend(library_id));
};

const isSubCategory = (slug: string): boolean => {
  return slug.includes('--');
}

  const formatCategoryName = (slug: string, isParent: boolean = false): string => {
    if (!slug) return '';

    const parts = slug.split('--');

    const textToFormat = isParent ? parts[0] : parts[parts.length - 1];

    return textToFormat
      .split('-')
      .map((word) => word.charAt(0) + word.slice(1))
      .join(' ');
  };

const categoriesHelpers = {
  cache,
  fetchCategoriesFromBackend,
  getCategories,
  isSubCategory,
  formatCategoryName,
};

export default categoriesHelpers;
